class NavigationEventEmitter {
  constructor() {
    this.listeners = new Map();
  }

  // Subscribe to navigation events
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);

    // Return unsubscribe function
    return () => {
      const callbacks = this.listeners.get(event);
      if (callbacks) {
        const index = callbacks.indexOf(callback);
        if (index > -1) {
          callbacks.splice(index, 1);
        }
      }
    };
  }

  // Emit navigation events
  emit(event, ...args) {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      callbacks.forEach((callback) => {
        try {
          callback(...args);
        } catch (error) {
          console.error('Navigation event handler error:', error);
        }
      });
    }
  }

  // Navigation methods that emit events
  navigate(path, options = {}) {
    this.emit('navigate', path, options);
  }

  replace(path, options = {}) {
    this.emit('navigate', path, { ...options, replace: true });
  }

  goBack() {
    this.emit('goBack');
  }

  goForward() {
    this.emit('goForward');
  }
}

// Export singleton instance
export const navigationEvents = new NavigationEventEmitter();

// Convenience functions for external navigation
export const navigateTo = (path, options) =>
  navigationEvents.navigate(path, options);

export const navigateReplace = (path, options) =>
  navigationEvents.replace(path, options);

export const goBack = () => navigationEvents.goBack();

export const goForward = () => navigationEvents.goForward();
